<div *ngIf="invoice as inv">

    <mat-card
        class="daxa-card customer-card mb-25 border-radius bg-white border-none d-block">
        <mat-card-content>

            <div class="text-center">
                <h4>{{ inv.user.name }}</h4>
                <span class="d-block text-body">
                    {{ inv.user.username }}
                </span>
            </div>

            <div class="info">
                <h5>{{'Details' | translate}}</h5>

                <ul class="pl-0 mb-0 list-unstyled mt-0">

                    <li class="text-body">
                        <span class="d-block text-black fw-medium">{{'User ID' | translate}}</span>
                        {{ inv.user.userId }}
                    </li>

                    <li class="text-body">
                        <span class="d-block text-black fw-medium">{{'Email' | translate}}</span>
                        {{ inv.user.email }}
                    </li>

                    <li class="text-body">
                        <span class="d-block text-black fw-medium">{{'Phone' | translate}}</span>
                        {{ inv.user.phone }}
                    </li>

                    <li class="text-body">
                        <span class="d-block text-black fw-medium">{{'Plant ID' | translate}}</span>
                        {{ inv.user.plantId }}
                    </li>

                    <li class="text-body">
                        <span class="d-block text-black fw-medium">{{'Subscription' | translate}}</span>
                        {{ inv.user.subscriptionType }}
                    </li>

                    <li class="text-body">
                        <span class="d-block text-black fw-medium">{{'HubSpot' | translate}}</span>
                        {{ inv.user.hubspotId }}
                    </li>

                    <li class="text-body">
                        <span class="d-block text-black fw-medium">{{'TraceLink' | translate}}</span>
                        {{ inv.user.tracelinkId }}
                    </li>

                </ul>
            </div>
        </mat-card-content>
    </mat-card>
</div>